/**
 * DRE Service
 * 
 * Serviço para buscar dados do DRE (Demonstração do Resultado do Exercício).
 */

import api from './api'

export const dreService = {
  /**
   * Buscar DRE para um período
   * @param {Number} month - Mês (1-12)
   * @param {Number} year - Ano
   * @returns {Promise} Dados do DRE
   */
  getDRE: async (month, year) => {
    try {
      const response = await api.get('/api/financial/dre', {
        params: { month, year }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar DRE:', error)
      throw error
    }
  },

  getCategoryTransactions: async ({ month, year, categoryId, sectionType }) => {
    try {
      const response = await api.get('/api/financial/dre/category-transactions', {
        params: { month, year, categoryId, sectionType }
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar lançamentos da categoria no DRE:', error)
      throw error
    }
  }
}
